<template>
  <div>{{ errMsg }}</div>
</template>

<script>
export default {
  data() {
    return {
      errMsg: this.$store.getters.errMsg
    }
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/error.vue